import * as React from 'react';
import { SelectSingle } from 'app/area/shared/translated-components';
import { ChangeOwnerFieldProps, ChangeOwnerField } from 'app/area/favourite-administration/list/change-owner/types';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { endpoints } from 'app/area/favourite-administration/form/endpoints';
import { FavouriteListIds } from 'app/area/favourite-administration/list/constants';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const ReplaceWithOwners = (props: ChangeOwnerFieldProps) => {
  const { list: { changeOwner: { form, validation } = {} }, options, translation, locale,
    loadOptions, updateByKey, resetValidation } = props;

  const fieldKey = ChangeOwnerField.toOwners;
  const { codes: rawCodes, fetching } = options?.[FavouriteListIds.toOwners] ?? {};
  const { replace_with_owners: labelText, search: searchPlaceholder } = translation ?? {};
  const valueItem = form?.[fieldKey];
  const codes = (rawCodes as ComplexValue<number>[]) ?? [];

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(FavouriteListIds.toOwners);
    updateByKey(fieldKey, value);
  };

  const onLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(FavouriteListIds.toOwners, endpoints.ownerOptions, loadOptionsParams);
  };

    return <SelectSingle
      componentId={FavouriteListIds.toOwners}
      className={'w-100'}
      valueItem={valueItem}
      label={{ text: labelText, visible: true, required: true }}
      options={codes}
      placeholder={searchPlaceholder}
      fetching={fetching}
      onLoadOptions={onLoadOptions}
      onChange={onChange}
      validation={validation?.toOwners}
      locale={locale} />;
};
